import ExtrasTablet from './ExtrasTablet';

export default ExtrasTablet;
export { ExtrasTablet };
